<template>
    <div>

      <BCard  class="mb-0">

        <BCardTitle>Evaluaciones</BCardTitle>
        <div class="">
          <BRow>

            <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>

            <BCol cols="12" md="8" lg="7" xl="6">
              <div class="d-flex align-items-center justify-content-between">
                <BFormInput disabled v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  />
                <BButton variant="primary" @click="showAddModal" v-if="ability.can('create', 'evaluation')"> <span class="text-nowrap">Añadir evaluacion</span> </BButton>
              </div>
            </BCol>

          </BRow>
        </div>

        <!-- Table -->
         <BTable borderless  ref="refDataListTable" class="position-relative mt-2" :items="fetchEvaluations" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc" >
          <template #cell(duration)="data">
            <small>
                <span><b>Desde: </b>{{ formatDate(data.item.start_date) }}</span><br>
                <span><b>Hasta: </b>{{ formatDate(data.item.end_date) }}</span>
            </small>
          </template>

          <template #cell(evaluation_date)="data">
            <span> {{ formatDate(data.item.end_date) }} </span>
          </template>

          <template #cell(weight)="data">
            <span>  {{ data.item.is_evaluable ? data.item.weight + '%' : 'No evaluable' }} </span>
          </template>

          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content> <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" /> </template>

              <BDropdownItem @click="showEditModal(data.item.id)" v-if="ability.can('write', 'evaluation')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopupAxios(data.item.id, `evaluations/${data.item.id}`)" v-if="ability.can('delete', 'evaluation')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>

            </BDropdown>
          </template> 
        </BTable> 

        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalData" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text> <feather-icon icon="ChevronLeftIcon" size="18" /> </template>
                <template #next-text> <feather-icon icon="ChevronRightIcon" size="18" /> </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>

      </BCard>

      <EvaluationsModal @refetch-data="refetchData"/>
    </div>
  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BDropdown, BDropdownItem, BPagination, BBadge, BCardTitle} from 'bootstrap-vue'
  import { provide, ref, inject, computed, watch } from '@vue/composition-api';
  import { avatarText } from '@core/utils/filter';
  import ability from '@/libs/acl/ability'
  import popups from '@/hooks/popups'
  import vSelect  from 'vue-select'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import EvaluationsModal from './EvaluationsAddEdit.vue';
  import { getEvaluations } from '@/composables/evaluationService';
  import dateUtils from '@/hooks/dateUtils'

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BDropdown, BDropdownItem, BPagination, vSelect, BBadge, TextInputValidated, BCardTitle, EvaluationsModal },
    emits: ['re-render-notes'],
    setup(props, {emit}){
      const { deletePopupAxios } = popups()
      const refDataListTable = ref(null)
      const evaluationsModal=ref(null)
      const addModal = ref(null)
      const evaluationId = ref (null)
      const evaluations = ref(null)
      const { formatDate } = dateUtils()

      // Query params
      const perPage = ref(10)
      const totalData = ref(0)
      const currentPage = ref(1)
      const perPageOptions = [10, 25, 50, 100]
      const searchQuery = ref('')
      const sortBy = ref('start_date')
      const isSortDirDesc = ref(false)
      
      // Table
      const tableColumns = [
        { key: 'name', label: 'Nombre' },
        { key: 'duration', label: 'Duración' },
        { key: 'evaluation_date', label: 'Fecha de evaluación' },
        { key: 'weight', label: 'Peso' },
        { key: 'actions', label: 'Acciones' },
      ]

      const course = inject('course')
      provide('evaluationsModal', evaluationsModal)
      provide('evaluationId', evaluationId)
      provide('addModal', addModal)

      const dataMeta = computed(() => {
          const localItemsCount = refDataListTable.value ? refDataListTable.value.localItems.length: 0
          return {
              from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
              to: perPage.value * (currentPage.value - 1) + localItemsCount,
              of: totalData.value,
          }
      });


      const fetchEvaluations = async function () {
        let response = await getEvaluations({
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            course: course.value.id
        })

        totalData.value = response.data.total
        evaluations.value = response.data.evaluations

        return evaluations.value
      }

      const refetchData = function() {
          refDataListTable.value.refresh()
          emit('re-render-notes')
      }

      const showAddModal = () => {
        addModal.value=true
        evaluationsModal.value.show()
      }

      const showEditModal = (id) => {
        evaluationId.value=id
        addModal.value=false
        evaluationsModal.value.show()
      }

      watch([currentPage, perPage, searchQuery], () => {
        refetchData()
      })

      return {
        avatarText,
        tableColumns,
        perPage,
        currentPage,
        totalData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refDataListTable,
        ability,
        deletePopupAxios,
        evaluationsModal, 
        evaluations, 
        fetchEvaluations,
        formatDate,
        showAddModal,
        showEditModal,
        refetchData
      }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
